import CoreLayout from '../../layouts/core-layout';
import { useTranslation } from "react-i18next";
import { LoginButton } from "../../lib/LoginButton";
import { useNavigate } from 'react-router-dom';

export const Error409 = () => {
  const { t } = useTranslation(); // Multi Language
  const navigate = useNavigate()
  return (
    <CoreLayout template="auth">
      <div className="row mt-10 text-white d-flex flex-column align-items-center justify-content-center" style={{ height: '75vh' }}>
        <div className="text-center" style={{ fontSize: "3rem" }}><b>{t('errors:error409.409')}</b></div>
        <div className="text-center mt-5" style={{ fontSize: "1.5rem" }}>{t('errors:error409.message409')}</div>
        <div className="text-center my-10 d-flex flex-column flex-lg-row align-items-center justify-content-center gap-4">
          <span>
            <LoginButton >
              <div className="btn btn-primary px-4 fs-4">
                {t('errors:error409.action.label')}
              </div>
            </LoginButton>
          </span>
          <button onClick={() => navigate(-1)} className="btn btn-primary px-4 fs-4">{t('errors:error404.return')}</button>
          <button onClick={() => { window.location.href = '/dashboard' }} className="btn btn-primary px-4 fs-4">{t('errors:error404.refresh')}</button>
        </div>
      </div>

    </CoreLayout>
  )
}
